/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetClipsClipIdCommentsParams,
  TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest,
  TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest,
  TrainWithMeModulesClipsDtosResponsesClipCommentPageResponse,
  TrainWithMeModulesClipsDtosResponsesClipCommentResponse,
  TrainWithMeModulesClipsDtosResponsesClipDownloadResponse,
  TrainWithMeModulesClipsDtosResponsesClipEntryResponse,
  TrainWithMeModulesClipsDtosResponsesPostClipSlotResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const deleteClipsClipId = (
    clipId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/clips/${clipId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteClipsClipIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClipsClipId>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClipsClipId>>, TError,{clipId: number}, TContext> => {

const mutationKey = ['deleteClipsClipId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClipsClipId>>, {clipId: number}> = (props) => {
          const {clipId} = props ?? {};

          return  deleteClipsClipId(clipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClipsClipIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClipsClipId>>>

    export type DeleteClipsClipIdMutationError = ErrorType<unknown>

    export const useDeleteClipsClipId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClipsClipId>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteClipsClipId>>,
        TError,
        {clipId: number},
        TContext
      > => {
      return useMutation(getDeleteClipsClipIdMutationOptions(options), queryClient);
    }
    export const getClipsClipId = (
    clipId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesClipEntryResponse>(
      {url: `/clips/${clipId}`, method: 'GET', signal
    },
      options);
    }




export const getGetClipsClipIdQueryKey = (clipId: number,) => {
    return [
    `/clips/${clipId}`
    ] as const;
    }


export const getGetClipsClipIdQueryOptions = <TData = Awaited<ReturnType<typeof getClipsClipId>>, TError = ErrorType<unknown>>(clipId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClipsClipIdQueryKey(clipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClipsClipId>>> = ({ signal }) => getClipsClipId(clipId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clipId !== null && clipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClipsClipId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClipsClipIdQueryResult = NonNullable<Awaited<ReturnType<typeof getClipsClipId>>>
export type GetClipsClipIdQueryError = ErrorType<unknown>


export function useGetClipsClipId<TData = Awaited<ReturnType<typeof getClipsClipId>>, TError = ErrorType<unknown>>(
 clipId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClipsClipId>>,
          TError,
          Awaited<ReturnType<typeof getClipsClipId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClipsClipId<TData = Awaited<ReturnType<typeof getClipsClipId>>, TError = ErrorType<unknown>>(
 clipId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClipsClipId>>,
          TError,
          Awaited<ReturnType<typeof getClipsClipId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClipsClipId<TData = Awaited<ReturnType<typeof getClipsClipId>>, TError = ErrorType<unknown>>(
 clipId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClipsClipId<TData = Awaited<ReturnType<typeof getClipsClipId>>, TError = ErrorType<unknown>>(
 clipId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClipsClipIdQueryOptions(clipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClipsClipIdComments = (
    clipId: number,
    params?: GetClipsClipIdCommentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesClipCommentPageResponse>(
      {url: `/clips/${clipId}/comments`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetClipsClipIdCommentsQueryKey = (clipId: number,
    params?: GetClipsClipIdCommentsParams,) => {
    return [
    `/clips/${clipId}/comments`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClipsClipIdCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getClipsClipIdComments>>, TError = ErrorType<unknown>>(clipId: number,
    params?: GetClipsClipIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipIdComments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClipsClipIdCommentsQueryKey(clipId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClipsClipIdComments>>> = ({ signal }) => getClipsClipIdComments(clipId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clipId !== null && clipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClipsClipIdComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClipsClipIdCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getClipsClipIdComments>>>
export type GetClipsClipIdCommentsQueryError = ErrorType<unknown>


export function useGetClipsClipIdComments<TData = Awaited<ReturnType<typeof getClipsClipIdComments>>, TError = ErrorType<unknown>>(
 clipId: number,
    params: undefined |  GetClipsClipIdCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipIdComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClipsClipIdComments>>,
          TError,
          Awaited<ReturnType<typeof getClipsClipIdComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClipsClipIdComments<TData = Awaited<ReturnType<typeof getClipsClipIdComments>>, TError = ErrorType<unknown>>(
 clipId: number,
    params?: GetClipsClipIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipIdComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClipsClipIdComments>>,
          TError,
          Awaited<ReturnType<typeof getClipsClipIdComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClipsClipIdComments<TData = Awaited<ReturnType<typeof getClipsClipIdComments>>, TError = ErrorType<unknown>>(
 clipId: number,
    params?: GetClipsClipIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipIdComments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClipsClipIdComments<TData = Awaited<ReturnType<typeof getClipsClipIdComments>>, TError = ErrorType<unknown>>(
 clipId: number,
    params?: GetClipsClipIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClipsClipIdComments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClipsClipIdCommentsQueryOptions(clipId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postClipsClipIdComments = (
    clipId: number,
    trainWithMeModulesClipsDtosRequestsPostClipCommentRequest?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesClipCommentResponse>(
      {url: `/clips/${clipId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClipsDtosRequestsPostClipCommentRequest, signal
    },
      options);
    }




export const getPostClipsClipIdCommentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdComments>>, TError,{clipId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdComments>>, TError,{clipId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest>}, TContext> => {

const mutationKey = ['postClipsClipIdComments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postClipsClipIdComments>>, {clipId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest>}> = (props) => {
          const {clipId,data} = props ?? {};

          return  postClipsClipIdComments(clipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostClipsClipIdCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof postClipsClipIdComments>>>
    export type PostClipsClipIdCommentsMutationBody = BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest> | undefined
    export type PostClipsClipIdCommentsMutationError = ErrorType<unknown>

    export const usePostClipsClipIdComments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdComments>>, TError,{clipId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postClipsClipIdComments>>,
        TError,
        {clipId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipCommentRequest>},
        TContext
      > => {
      return useMutation(getPostClipsClipIdCommentsMutationOptions(options), queryClient);
    }
    export const deleteClipsClipIdCommentsCommentId = (
    clipId: number,
    commentId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/clips/${clipId}/comments/${commentId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteClipsClipIdCommentsCommentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClipsClipIdCommentsCommentId>>, TError,{clipId: number;commentId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClipsClipIdCommentsCommentId>>, TError,{clipId: number;commentId: number}, TContext> => {

const mutationKey = ['deleteClipsClipIdCommentsCommentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClipsClipIdCommentsCommentId>>, {clipId: number;commentId: number}> = (props) => {
          const {clipId,commentId} = props ?? {};

          return  deleteClipsClipIdCommentsCommentId(clipId,commentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClipsClipIdCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClipsClipIdCommentsCommentId>>>

    export type DeleteClipsClipIdCommentsCommentIdMutationError = ErrorType<unknown>

    export const useDeleteClipsClipIdCommentsCommentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClipsClipIdCommentsCommentId>>, TError,{clipId: number;commentId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteClipsClipIdCommentsCommentId>>,
        TError,
        {clipId: number;commentId: number},
        TContext
      > => {
      return useMutation(getDeleteClipsClipIdCommentsCommentIdMutationOptions(options), queryClient);
    }
    export const patchClipsClipIdCommentsCommentId = (
    clipId: number,
    commentId: number,
    trainWithMeModulesClipsDtosRequestsPatchClipCommentRequest?: BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesClipCommentResponse>(
      {url: `/clips/${clipId}/comments/${commentId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClipsDtosRequestsPatchClipCommentRequest, signal
    },
      options);
    }




export const getPatchClipsClipIdCommentsCommentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClipsClipIdCommentsCommentId>>, TError,{clipId: number;commentId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchClipsClipIdCommentsCommentId>>, TError,{clipId: number;commentId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest>}, TContext> => {

const mutationKey = ['patchClipsClipIdCommentsCommentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchClipsClipIdCommentsCommentId>>, {clipId: number;commentId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest>}> = (props) => {
          const {clipId,commentId,data} = props ?? {};

          return  patchClipsClipIdCommentsCommentId(clipId,commentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchClipsClipIdCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchClipsClipIdCommentsCommentId>>>
    export type PatchClipsClipIdCommentsCommentIdMutationBody = BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest> | undefined
    export type PatchClipsClipIdCommentsCommentIdMutationError = ErrorType<unknown>

    export const usePatchClipsClipIdCommentsCommentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClipsClipIdCommentsCommentId>>, TError,{clipId: number;commentId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchClipsClipIdCommentsCommentId>>,
        TError,
        {clipId: number;commentId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPatchClipCommentRequest>},
        TContext
      > => {
      return useMutation(getPatchClipsClipIdCommentsCommentIdMutationOptions(options), queryClient);
    }
    export const postClipsClipIdDownload = (
    clipId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesClipDownloadResponse>(
      {url: `/clips/${clipId}/download`, method: 'POST', signal
    },
      options);
    }




export const getPostClipsClipIdDownloadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdDownload>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdDownload>>, TError,{clipId: number}, TContext> => {

const mutationKey = ['postClipsClipIdDownload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postClipsClipIdDownload>>, {clipId: number}> = (props) => {
          const {clipId} = props ?? {};

          return  postClipsClipIdDownload(clipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostClipsClipIdDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postClipsClipIdDownload>>>

    export type PostClipsClipIdDownloadMutationError = ErrorType<unknown>

    export const usePostClipsClipIdDownload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdDownload>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postClipsClipIdDownload>>,
        TError,
        {clipId: number},
        TContext
      > => {
      return useMutation(getPostClipsClipIdDownloadMutationOptions(options), queryClient);
    }
    export const postClipsClipIdSeen = (
    clipId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/clips/${clipId}/seen`, method: 'POST', signal
    },
      options);
    }




export const getPostClipsClipIdSeenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdSeen>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdSeen>>, TError,{clipId: number}, TContext> => {

const mutationKey = ['postClipsClipIdSeen'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postClipsClipIdSeen>>, {clipId: number}> = (props) => {
          const {clipId} = props ?? {};

          return  postClipsClipIdSeen(clipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostClipsClipIdSeenMutationResult = NonNullable<Awaited<ReturnType<typeof postClipsClipIdSeen>>>

    export type PostClipsClipIdSeenMutationError = ErrorType<unknown>

    export const usePostClipsClipIdSeen = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdSeen>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postClipsClipIdSeen>>,
        TError,
        {clipId: number},
        TContext
      > => {
      return useMutation(getPostClipsClipIdSeenMutationOptions(options), queryClient);
    }
    export const postClipsClipIdSlot = (
    clipId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesPostClipSlotResponse>(
      {url: `/clips/${clipId}/slot`, method: 'POST', signal
    },
      options);
    }




export const getPostClipsClipIdSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdSlot>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdSlot>>, TError,{clipId: number}, TContext> => {

const mutationKey = ['postClipsClipIdSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postClipsClipIdSlot>>, {clipId: number}> = (props) => {
          const {clipId} = props ?? {};

          return  postClipsClipIdSlot(clipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostClipsClipIdSlotMutationResult = NonNullable<Awaited<ReturnType<typeof postClipsClipIdSlot>>>

    export type PostClipsClipIdSlotMutationError = ErrorType<unknown>

    export const usePostClipsClipIdSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClipsClipIdSlot>>, TError,{clipId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postClipsClipIdSlot>>,
        TError,
        {clipId: number},
        TContext
      > => {
      return useMutation(getPostClipsClipIdSlotMutationOptions(options), queryClient);
    }
